angular.module('unica_media.media_services')

.factory('MediaDeleteService', function ($http, getBaseApiURL) {

	var mediaDeleteService = {};

	mediaDeleteService.delete = function (mediaId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/media/delete/' + mediaId,
			data: {	}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return mediaDeleteService;
});